// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_38CZz","dangerous":"view-default_dangerous_2Uk2f"};